// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { ref, get } from "firebase/database";
// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
// import { auth, firestore, database as realtimeDB } from "../../FirebaseConfig"; // Import Firebase DBs
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import { Navigation, Autoplay } from "swiper/modules";
// import toast from "react-hot-toast";

// export default function BestSelling() {
//   const [bestSellingProducts, setBestSellingProducts] = useState([]);
//   const [bannerDeal, setBannerDeal] = useState("");
//   const [bannerTitle, setBannerTitle] = useState("");
//   const [bannerDesc, setBannerDesc] = useState("");


//   const handleAddToCart = async (product,id) => {
//     if (!auth.currentUser) {
//       toast.error("Please log in to add items to your cart.");
//       // alert("Please log in to add items to your cart.");
//       // navigate(`/login?redirect=/`);
//       return;
//     }

//     if (  product.stock<1) {

//       return
//     }
//       ;

//     // setAddingToCart(true);
//     const userId = auth.currentUser.uid;
//     const cartRef = doc(firestore, "customers", userId);
//     toast.loading("Adding Item .!");

//     try {
//       const cartSnap = await getDoc(cartRef);

//       if (cartSnap.exists()) {
//         const cartData = cartSnap.data();
//         let updatedCart = { ...cartData };

//         if (updatedCart.items) {
//           const existingItemIndex = updatedCart.items.findIndex(item => item.productId === id);

//           if (existingItemIndex !== -1) {
//             updatedCart.items[existingItemIndex].quantity += 1;
//           } else {
//             updatedCart.items.push({ productId: id, quantity:1 });
//           }
//         } else {
//           updatedCart = { items: [{ productId: id, quantity:1 }] };
//         }

//         await updateDoc(cartRef, updatedCart);
//       } else {
//         await setDoc(cartRef, { items: [{ productId: id, quantity:1 }] });
//       }
//       toast.dismiss();
//       toast.success("Item added to cart!");
//     } catch (error) {
//       toast.dismiss();

//       console.error("Error adding to cart:", error);
//       toast.error("Error adding item to cart. Please try again.");
//     }

//     // setAddingToCart(false);
//   };



//   useEffect(() => {
//     const fetchBestSellingData = async () => {
//       const bestSellRef = ref(realtimeDB, "bestSell");
//       const snapshot = await get(bestSellRef);

//       if (snapshot.exists()) {
//         const data = snapshot.val();
//         setBannerDeal(data.bannerIcon);

//         setBannerDesc(data.bannerDesc);
//         setBannerTitle(data.bannerTitle);
//         // Fetch product details from Firestore using product IDs
//         const productPromises = data.products.map(async (productId) => {
//           const productRef = doc(firestore, "products", productId);
//           const productSnap = await getDoc(productRef);

//           return productSnap.exists() ? { id: productId, ...productSnap.data() } : null;
//         });

//         const fetchedProducts = (await Promise.all(productPromises)).filter(Boolean);
//         setBestSellingProducts(fetchedProducts);
//       }
//     };

//     fetchBestSellingData();
//   }, []);


// //   .wt-separator {
// //     display: block;
// //     height: 2px;
// //     margin-bottom: 5px !important;
// //     margin: auto;
// //     position: relative;
// //     transition: width 0.3s ease;
// //     width: 40px;
// //   }
// //   .wt-separator2 {
// //     display: block;
// //     height: 2px;
// //     margin: auto;
// //     position: relative;
// //     transition: width 0.3s ease;
// //     width: 60px;
// //   }

  

// return (
//   <div className="m-5">
//     <div className="text-center mb-6">
//       <h3 className="text-2xl font-bold">Best Sellers</h3>
//       <div className="w-16 h-1 bg-orange-500 mx-auto mt-2"></div>
//     </div>

//     <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
//       {/* Left Side Banner */}
//       <div
//         className="bg-cover hidden md:block bg-center h-80 flex items-center justify-center p-6 rounded-md shadow-lg"
//         style={{ backgroundImage: `url(${bannerDeal})` }}
//       >
//         <div className="text-black text-center">
//           {/* <h3 className="text-xl font-bold">{bannerTitle}</h3>
//           <p className="mt-2">{bannerDesc}</p>
//           <Link
//             to="/shop"
//             className="mt-2 inline-block bg-black p-2 text-orange-500 py-2 rounded-md"
//           >
//             Shop Now
//           </Link> */}
//         </div>
//       </div>

//       {/* Right Side Swiper for Best Selling Products */}
//       <div className="col-span-2">
//         {bestSellingProducts.length === 0 ? (
//           // Shimmer Effect for Loading Products
//           <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//             {[1, 2].map((index) => (
//               <div key={index} className="border rounded-md p-4 bg-white shadow-md animate-pulse">
//                 <div className="h-40 bg-gray-200 rounded-md"></div>
//                 <div className="mt-3">
//                   <div className="h-4 bg-gray-300 w-3/4 rounded-md"></div>
//                   <div className="mt-2 h-4 bg-gray-300 w-1/2 rounded-md"></div>
//                 </div>
//                 <div className="mt-4 h-8 bg-gray-400 w-full rounded-md"></div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <Swiper
//             modules={[Navigation, Autoplay]}
//             spaceBetween={10}
//             slidesPerView={1}
//             breakpoints={{
//               1024: { slidesPerView: 3 }, // For large screens
//               492: { slidesPerView: 2 }, // For medium screens
//             }}
//             autoplay={{ delay: 2500 }}
//             className="rounded-md"
//           >
//             {bestSellingProducts.map((product) => {
//               const actualPrice = product.prices.productPrice;
//               const offerPrice = actualPrice - product.prices.productDiscount;
//               const discountPercent = (
//                 (product.prices.productDiscount / actualPrice) *
//                 100
//               ).toFixed(0);

//               return (
//                 <SwiperSlide key={product.id}>
//                   <div className="border rounded-md p-2 bg-white shadow-md">
//                     <Link to={`/product/${product.id}`} className="block text-center">
//                       <img
//                         src={product.thumbnail}
//                         alt={product.name}
//                         className="md:h-45 h-50 object-contain mx-auto"
//                       />
//                     </Link>
//                     <div className="mt-3 text-center">
//                       <h4 className="text-md font-semibold">{product.name}</h4>
//                       <div className="flex justify-center items-center mt-1 space-x-2">
//                         {product.prices.productDiscount > 0 ? (
//                           <>
//                             <span className="text-lg font-bold text-green-600">₹{offerPrice}</span>
//                             <span className="text-sm line-through text-gray-500">₹{actualPrice}</span>
//                             <span className="text-sm bg-red-500 text-white px-2 py-1 rounded-md">
//                               {discountPercent}% OFF
//                             </span>
//                           </>
//                         ) : (
//                           <span className="text-lg font-bold text-gray-800">₹{actualPrice}</span>
//                         )}
//                       </div>
//                       <button
//                         onClick={() => handleAddToCart( product,product.id)}
//                         className="mt-3 bg-orange-500 font-bold text-white px-4 py-2 rounded-md w-40"
//                       >
//                         Add to Cart
//                       </button>
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               );
//             })}
//           </Swiper>
//         )}
//       </div>
//     </div>
//   </div>
// );

// }
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ref, get } from "firebase/database";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { auth, firestore, database as realtimeDB } from "../../FirebaseConfig";
import toast from "react-hot-toast";
import { motion } from "framer-motion";

// Icons
const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
);
const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
);

export default function BestSelling() {
  const [bestSellingProducts, setBestSellingProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollContainerRef = useRef(null);
  const navigate = useNavigate();

  // --- Scroll Logic ---
  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      // Adjusted scroll amount for compact cards
      const scrollAmount = 250; 
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // --- Cart Logic ---
  const handleAddToCart = async (e, product, id) => {
    e.stopPropagation(); 

    if (!auth.currentUser) {
      toast.error("Please log in.");
      return;
    }

    if (product.stock < 1) {
      toast.error("Out of stock.");
      return;
    }

    const userId = auth.currentUser.uid;
    const cartRef = doc(firestore, "customers", userId);
    const loadingToastId = toast.loading("Adding...");

    try {
      const cartSnap = await getDoc(cartRef);
      let updatedCart = { items: [] };

      if (cartSnap.exists()) {
        updatedCart = cartSnap.data() || { items: [] };
      }

      if (!Array.isArray(updatedCart.items)) {
        updatedCart.items = [];
      }

      const existingItemIndex = updatedCart.items.findIndex((item) => item.productId === id);

      if (existingItemIndex !== -1) {
        updatedCart.items[existingItemIndex].quantity += 1;
      } else {
        updatedCart.items.push({ productId: id, quantity: 1 });
      }

      if (cartSnap.exists()) {
        await updateDoc(cartRef, updatedCart);
      } else {
        await setDoc(cartRef, updatedCart);
      }

      toast.dismiss(loadingToastId);
      toast.success("Added!");
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.dismiss(loadingToastId);
      toast.error("Failed.");
    }
  };

  // --- Data Fetching ---
  useEffect(() => {
    const fetchBestSellingData = async () => {
      setLoading(true);
      try {
        const bestSellRef = ref(realtimeDB, "bestSell");
        const snapshot = await get(bestSellRef);

        if (snapshot.exists()) {
          const data = snapshot.val();
          const productPromises = data.products.map(async (productId) => {
            const productRef = doc(firestore, "products", productId);
            const productSnap = await getDoc(productRef);
            return productSnap.exists() ? { id: productId, ...productSnap.data() } : null;
          });

          const fetchedProducts = (await Promise.all(productPromises)).filter(Boolean);
          setBestSellingProducts(fetchedProducts);
        }
      } catch (e) {
        console.error("Error fetching data", e);
      } finally {
        setLoading(false);
      }
    };

    fetchBestSellingData();
  }, []);

  return (
    <div className="py-6 px-3  mx-auto relative bg-white">
      {/* --- Section Header (Compact) --- */}
      <div className="flex items-center gap-3 mb-4 px-1">
        <h3 className="text-xl md:text-2xl font-bold text-gray-900">
          Best Sellers
        </h3>
        <div className="h-0.5 bg-orange-200 flex-grow rounded-full"></div>
        {/* <Link to="/shop" className="text-xs font-semibold text-orange-600 hover:text-orange-700">View All</Link> */}
      </div>

      {loading ? (
        // --- Compact Loading Shimmer ---
        <div className="flex gap-3 overflow-hidden pb-4">
          {[1, 2, 3, 4, 5].map((index) => (
            <div key={index} className="min-w-[170px] md:min-w-[220px] bg-gray-50 rounded-xl p-3 border border-gray-100 animate-pulse">
              <div className="h-32 bg-gray-200 rounded-lg mb-3"></div>
              <div className="h-3 bg-gray-200 rounded w-3/4 mx-auto mb-2"></div>
              <div className="h-8 bg-gray-200 rounded-full w-full"></div>
            </div>
          ))}
        </div>
      ) : (
        <div className="relative group">
          {/* --- Left Navigation Arrow --- */}
          <button 
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 -translate-y-1/2 -ml-3 z-20 bg-white border border-gray-100 shadow-lg rounded-full p-2 text-gray-600 hover:text-orange-600 hover:scale-110 transition-all hidden md:block opacity-0 group-hover:opacity-100"
          >
            <ChevronLeft />
          </button>

          {/* --- Horizontal Scroll Container (Tight Gap) --- */}
          <div 
            ref={scrollContainerRef}
            className="flex gap-3 md:gap-4 overflow-x-auto scroll-smooth pb-4 px-1 hide-scrollbar items-stretch"
          >
            {bestSellingProducts.map((product) => (
              <SingleProductCard 
                key={product.id} 
                data={product} 
                handleAddToCart={handleAddToCart}
                navigate={navigate}
              />
            ))}
          </div>

          {/* --- Right Navigation Arrow --- */}
          <button 
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 -translate-y-1/2 -mr-3 z-20 bg-white border border-gray-100 shadow-lg rounded-full p-2 text-gray-600 hover:text-orange-600 hover:scale-110 transition-all hidden md:block opacity-0 group-hover:opacity-100"
          >
            <ChevronRight />
          </button>
        </div>
      )}

      {/* Hide Scrollbar CSS */}
      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}

// --- Compact Premium Card ---
const SingleProductCard = ({ data, handleAddToCart, navigate }) => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  const isDiscounted = data.prices?.productDiscount > 0;
  const isInStock = data.stock > 0;
  const effectivePrice = data.prices?.productPrice - (data.prices?.productDiscount || 0);
  const rating = data.rating || 0;
  const ratingCount = data.ratingCount || 0;
  const hasRating = rating > 0;

  return (
    <motion.div
      onClick={() => navigate(`/product/${data.id}`)}
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.98 }}
      // Key Change: Width Reduced (170px Mobile, 240px Desktop)
      className="bg-gradient-to-br from-amber-50/50 to-yellow-50/50 rounded-2xl border border-amber-100/60 shadow-sm hover:shadow-lg transition-all cursor-pointer 
      min-w-[170px] w-[170px] md:min-w-[230px] md:w-[230px] 
      flex flex-col pb-3 overflow-hidden"
    >
      {/* Image Area - Reduced Height */}
      <div className={`relative w-full flex justify-center items-center bg-white p-3 ${isImageLoading ? "h-[140px]" : "h-auto"}`}>
        
        {isImageLoading && <div className="absolute inset-0 bg-gray-50 animate-pulse" />}

        <img
          src={data.thumbnail}
          alt={data.name}
          // Height reduced: h-32 (mobile) / h-40 (desktop)
          className={`w-full h-32 md:h-40 object-contain mix-blend-multiply transition-opacity duration-500 ${
            isImageLoading ? "opacity-0" : "opacity-100"
          }`}
          onLoad={() => setIsImageLoading(false)}
          onError={() => setIsImageLoading(false)}
        />

        {/* Badges - Made Smaller */}
        {data.status !== "Normal" && (
          <div className={`absolute top-2 left-2 px-1.5 py-0.5 rounded text-[9px] font-bold uppercase ${
            isInStock ? "bg-red-500 text-white" : "bg-gray-400 text-white"
          }`}>
            {isInStock ? data.status : "Sold Out"}
          </div>
        )}

        {/* Rating - Compact & Translucent */}
        {hasRating && (
          <div className="absolute bottom-1 right-1 flex items-center gap-0.5 bg-white/80 backdrop-blur-sm px-1.5 py-0.5 rounded-full border border-gray-100 shadow-sm">
            <span className="text-amber-500 text-[10px]">★</span>
            <span className="text-[10px] font-bold text-gray-700">{rating.toFixed(1)}</span>
          </div>
        )}
      </div>

      {/* Details Area - Compact Padding */}
      <div className="px-3 mt-2 flex-grow flex flex-col justify-between">
        <div>
          <h3 className="text-sm md:text-[15px] font-semibold text-gray-800 truncate leading-tight">
            {data.name}
          </h3>
          
          {/* Price - Tighter */}
          <div className="mt-1 flex items-baseline gap-1.5">
            <span className="text-amber-700 font-bold text-base md:text-lg">
              ₹{effectivePrice}
            </span>
            {isDiscounted && (
              <span className="text-gray-400 line-through text-[10px] md:text-xs">
                ₹{data.prices.productPrice}
              </span>
            )}
          </div>
        </div>

        {/* Action Button - Compact Height */}
        <button
          onClick={(e) => handleAddToCart(e, data, data.id)}
          disabled={!isInStock}
          className={`mt-3 w-full py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-bold shadow-sm active:scale-95 transition-transform
            ${
              !isInStock
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-emerald-600 hover:bg-emerald-700 text-white"
            }`}
        >
          {!isInStock ? "Stock Out" : "Add 🍯"}
        </button>
      </div>
    </motion.div>
  );
};